import { render, staticRenderFns } from "./AppProduct.vue?vue&type=template&id=60423be5&scoped=true&"
import script from "./AppProduct.vue?vue&type=script&lang=js&"
export * from "./AppProduct.vue?vue&type=script&lang=js&"
import style0 from "./AppProduct.vue?vue&type=style&index=0&id=60423be5&prod&lang=scss&scoped=true&"
import style1 from "./AppProduct.vue?vue&type=style&index=1&id=60423be5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60423be5",
  null
  
)

export default component.exports